import CosmosJobsDbRecordBase from '@/models/CosmosJobsDbRecordBase'

export default class PolicyEnquiry extends CosmosJobsDbRecordBase {
  public description: string
  public category: string
}
